import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("Check your inbox.");
    } catch (err) {
      // Never reveal existence — still show generic success
      setDone(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="sv-overline mb-3 text-center">Password Reset</div>
        <h1 className="font-serif-hero text-4xl text-center text-[#F4E4BC]">Forgot your password?</h1>
        <p className="text-sm text-[#8A8478] text-center mt-4">
          Enter your email and we'll send you a secure link to set a new one.
        </p>
        {done ? (
          <div className="mt-10 sv-card p-8 text-center" data-testid="forgot-password-success">
            <div className="font-serif-editorial text-xl text-[#F4E4BC]">Check your email.</div>
            <p className="text-sm text-[#8A8478] mt-3">
              If <strong className="text-[#CDC7BA]">{email}</strong> is registered with SV Talent, a reset link is on its way.
              The link expires in 60 minutes and can be used once.
            </p>
            <Link to="/login" className="inline-block mt-6 sv-btn-outline text-xs">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-4">
            <input data-testid="forgot-email" required type="email" placeholder="Email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl focus:border-[#C5A059] outline-none" />
            <button data-testid="forgot-submit" disabled={busy} className="sv-btn-primary w-full">
              {busy ? "Sending…" : "Send Reset Link"}
            </button>
            <p className="text-center text-sm text-[#8A8478] mt-4">
              Remembered it? <Link to="/login" className="text-[#C5A059]">Sign in</Link>
            </p>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}
